"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villa-estense": {
    "2cc385b9": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "skipSearch": false
    }],
    "capoluogo": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60592cbe": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "skipSearch": false
    }],
    "finale": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31f5c2b9": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "skipSearch": false
    }],
    "grompa": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db6a0305": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "skipSearch": false
    }],
    "pilastro": [{
      "hkey": "e5bf7c25",
      "slug": "villa-estense",
      "name": "Villa Estense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;